<template>
  <div class="rhg-instructions-map__error">
    <i class="rhg-font-icon--no-results"></i>
    <p class="rhg-instructions-map__message">{{message}}</p>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    message: String
  }
}
</script>

<style lang="scss">
.rhg-instructions-map {
  &__error {
    display: flex;
    gap: 8px;
    top: 52px;
    position: absolute;
    background: white;
    box-shadow: 2px 2px 10px 10px rgba(black, 0.2);
    border-radius: 8px;
    z-index: 5;
    width: 100%;
    padding: 20px;

    @media (min-width: 992px) {
      top: 56px;
    }
  }

  &__message {
    margin: 0;
    align-self: center;
  }
}
</style>
